import React, { useState } from 'react'; 
import '../style/Tour.css';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import { FaRegStar, FaPhoneAlt, FaRegImage, FaRegCommentDots } from 'react-icons/fa';
import { Modal, Button, Carousel } from 'react-bootstrap';
import angamaImage from '../img/Angama - Home.jpg'; 
import simienMountains from '../img/Simien Mountains - Ethiopia.jpg';
import omoValley from '../img/Ethiopia travel.jpg';
import lalibelaChurches from '../img/gonder.jpg';
import danakilDepression from '../img/Ethiopia.jpg';


const Tour = () => {
  const [showContact, setShowContact] = useState(false);
  const [showGallery, setShowGallery] = useState(false);
  const [currentTour, setCurrentTour] = useState(null); // Track the current tour for the gallery

  const toggleContact = () => setShowContact(!showContact);
  const toggleGallery = (tour) => {
    setCurrentTour(tour); // Set the current tour for gallery
    setShowGallery(!showGallery);
  };

  // Tour data for different areas in Ethiopia
  const tours = [
    {
      name: "Arba Minch",
      description: "Day 1: In the morning, you drive to Arba Minch and Dorze, enjoying a beautiful panorama over Lake Chamo and the surrounding area. A scenic tour through the highlands awaits.",
      image: angamaImage,
      contactName: "John Doe",
      contactPhone: "+251 123 456 789",
      galleryImages: [angamaImage, simienMountains, omoValley] // Different images for gallery
    },
    {
      name: "Simien Mountains",
      description: "Explore the dramatic landscapes of the Simien Mountains, known for its rugged terrain, wildlife, and stunning vistas. Perfect for trekking and nature lovers.",
      image: simienMountains,
      contactName: "Jane Smith",
      contactPhone: "+251 987 654 321",
      galleryImages: [simienMountains, omoValley, lalibelaChurches] // Different images for gallery
    },
    {
      name: "Omo Valley",
      description: "Discover the cultural diversity of the Omo Valley, home to several indigenous tribes. Visit local villages and experience their unique traditions and lifestyles.",
      image: omoValley,
      contactName: "Alice Johnson",
      contactPhone: "+251 555 123 456",
      galleryImages: [omoValley, lalibelaChurches, danakilDepression] // Different images for gallery
    },
    {
      name: "Lalibela",
      description: "Lalibela, famous for its rock-hewn churches, is a UNESCO World Heritage site. Explore this ancient religious complex, which is one of Ethiopia’s holiest places.",
      image: lalibelaChurches,
      contactName: "Bob Brown",
      contactPhone: "+251 654 789 012",
      galleryImages: [lalibelaChurches, danakilDepression, angamaImage] // Different images for gallery
    },
    {
      name: "Danakil Depression",
      description: "The Danakil Depression is one of the hottest and most inhospitable places on Earth. Visit this unique area to witness volcanic landscapes and salt flats.",
      image: danakilDepression,
      contactName: "Charlie Green",
      contactPhone: "+251 741 852 963",
      galleryImages: [danakilDepression, simienMountains, omoValley] // Different images for gallery
    }
  ];

  return (
    <div>
      <section className="tour-hero-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1 className="tour-heading">Tour</h1>
            </div>
          </div>
        </div>
      </section>

      {/* Row to display cards */}
      <div className="container">
        <div className="row justify-content-center">
          {tours.map((tour, index) => (
            <div key={index} className="col-md-4 col-sm-6 col-xs-12 mb-4">
              <Card className="tour-card">
                <Card.Img variant="top" src={tour.image} className="tour-images" />
                <Card.Body>
                <div className="d-flex justify-content-between align-items-center">
  <span className="book-now">Book Now</span>
</div>
                  <Card.Title className="tour-title">{tour.name}</Card.Title>
                  <Card.Text className="tour-description">
                    {tour.description}
                  </Card.Text>
                </Card.Body>
                <ListGroup className="list-group-flush">
                  <ListGroup.Item className="list-item">
                    <div className="d-flex justify-content-between">
                      <div>
                        <FaRegStar className="icon" /> Details
                      </div>
                      <div>
                        <FaRegCommentDots className="icon" /> Message
                      </div>
                      <div>
                        <FaRegImage className="icon" onClick={() => toggleGallery(tour)} style={{ cursor: 'pointer' }} /> Zoom
                      </div>
                    </div>
                  </ListGroup.Item>
                </ListGroup>
                <Card.Body>
                  <div className="d-flex justify-content-between">
                    <div>
                      <FaRegStar className="icon" /> Tour
                    </div>
                    <div>
                      <FaPhoneAlt className="icon" onClick={toggleContact} style={{ cursor: 'pointer' }} /> Contact
                    </div>
                  </div>
                </Card.Body>

                {/* Contact Modal */}
                <Modal show={showContact} onHide={toggleContact}>
                  <Modal.Header closeButton>
                    <Modal.Title>Contact</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <p>Name: {tour.contactName}</p>
                    <p>Phone: {tour.contactPhone}</p>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={toggleContact}>
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>

                {/* Gallery Modal with Carousel */}
                <Modal show={showGallery} onHide={toggleGallery} size="lg">
                  <Modal.Header closeButton>
                    <Modal.Title>Gallery</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Carousel>
                      {currentTour && currentTour.galleryImages.map((image, index) => (
                        <Carousel.Item key={index}>
                          <img src={image} alt={currentTour.name} className="d-block w-100" />
                        </Carousel.Item>
                      ))}
                    </Carousel>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={toggleGallery}>
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>
              </Card>
            </div>
          ))}
        </div>
      </div>
      <section class="py-5 bg-light">
    <div class="container">
        <div class="row justify-content-center align-items-center">
    
            <div class="col-lg-6 mb-5 mb-lg-0">
                <div class="pe-lg-3">
                    <h1 class="display-3 fw-bold mb-2 mb-md-3">Book Your Dream Tour with <span class="text-primary">Vana Tours</span></h1>
                    <p class="lead mb-4">Explore stunning destinations and enjoy a hassle-free experience. Choose from a variety of packages and enjoy a once-in-a-lifetime journey.</p>
                </div>
                <div class="row">
                
                    <div class="col-sm-6 mb-3 mb-sm-0">
                        <div class="d-flex">
                            <div class="flex-shrink-0">
                                <div class="text-primary">
                                    <svg class="bi bi-chat-right-fill" fill="currentColor" height="32" viewbox="0 0 16 16" width="32" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14 0a2 2 0 0 1 2 2v12.793a.5.5 0 0 1-.854.353l-2.853-2.853a1 1 0 0 0-.707-.293H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12z"></path>
                                    </svg>
                                </div>
                            </div>
                            <div class="ms-3">
                                <h6 class="mb-0">24/7</h6>
                                <p>Customer Support</p>
                            </div>
                        </div>
                    </div>
             
                    <div class="col-sm-6">
                        <div class="d-flex">
                            <div class="text-primary">
                                <svg class="bi bi-shield-fill-check" fill="currentColor" height="32" viewbox="0 0 16 16" width="32" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zm2.146 5.146a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647z" fill-rule="evenodd"></path>
                                </svg>
                            </div>
                            <div class="ms-3">
                                <h6 class="mb-0">99.99%</h6>
                                <p>Uptime Guarantee</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
     
            <div class="col-lg-6">
                <div class="ps-lg-5">
                    <div class="card shadow-lg border border-primary text-white text-left h-100">
                        <div class="card-body bg-primary p-4 p-xl-5">
                            <h2 class="pb-3 text-center">Book Your Tour and Car Rental Now!</h2>
                            <form>
                                <div class="mb-3">
                                    <label class="form-label" for="name">Full Name</label>
                                    <input type="text" className="form-control" id="name" placeholder="Enter your name"  />
                                </div>
                                <div class="mb-3">
                                    <label class="form-label" for="email">Email Address</label>
                                    <input type="email" className="form-control" id="email" placeholder="Enter your email" />
                  
                                </div>
                                <div class="mb-3">
                                    <label class="form-label" for="phone">Phone Number</label>
                                    <input type="text" className="form-control" id="phone" placeholder="Enter your phone number"  />
                                </div>
                                <div class="mb-3">
                                    <label class="form-label" for="tourArea">Tour Area</label>
                                    <select class="form-select" id="tourArea" required>
                                        <option value="">Select a tour destination</option>
                                        <option value="Arba Minch">Arba Minch</option>
                                        <option value="Simien Mountains">Simien Mountains</option>
                                        <option value="Omo Valley">Omo Valley</option>
                                        <option value="Lalibela">Lalibela</option>
                                        <option value="Danakil Depression">Danakil Depression</option>
                                    </select>
                                </div>
                                <div class="mb-3">
                                    <label class="form-label" for="tripSize">Trip Size</label>
                                    <select class="form-select" id="tripSize" required>
                                        <option value="">Select trip size</option>
                                        <option value="Solo">Solo</option>
                                        <option value="Group (2-5 people)">Group (2-5 people)</option>
                                        <option value="Group (6-10 people)">Group (6-10 people)</option>
                                        <option value="Large Group (10+ people)">Large Group (10+ people)</option>
                                    </select>
                                </div>
                                <div class="mb-3">
                                    <label class="form-label" for="carRental">Car Rental</label>
                                    <select class="form-select" id="carRental" required>
                                        <option value="">Choose a car</option>
                                        <option value="Sedan">Sedan</option>
                                        <option value="SUV">SUV</option>
                                        <option value="Minivan">Minivan</option>
                                        <option value="4x4">4x4</option>
                                    </select>
                                </div>
                                <button class="btn btn-dark btn-lg" type="submit">Book Now</button>
                                <p class="mt-3 small fst-italic text-light">*Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="py-3">
	<div class="container">
		<div class="row">
			<div class="col-md-6">
				<div class="bg-light border p-4 rounded text-center">
					<span class="text-muted">Discover Our Services</span>
					<h2 class="fw-bold display-6 mb-3">Vana Tour & Car Rental</h2>
					<p class="text-dark mb-3">Explore the best vacation spots with our affordable and comfortable van tours and car rentals. Book your trip today and experience convenience and luxury on the road!</p>
					<a href="#" class="btn btn-primary text-nowrap">Learn More</a>
				</div>
			</div>
			<div class="col-md-6">
				<div class="bg-primary p-4 mt-md-0 mt-3 rounded text-center">
					<span class="text-light">Limited Time Offer</span>
					<h2 class="text-white fw-bold display-6 mb-3">Special Discounts on All Rentals!</h2>
					<p class="text-light mb-3">Save more on your next tour and car rental. Don’t miss out on our exclusive deals. Plan your getaway with us!</p>
					<a class="btn btn-outline-light" href="#">Get Your Discount</a>
				</div>
			</div>
		</div>
	</div>
</section>

    </div>
  );
}

export default Tour;



